import { fromCognitoIdentityPool } from '@aws-sdk/credential-providers';
import { FirehoseClient, PutRecordCommand } from '@aws-sdk/client-firehose';
import { EventWriter } from 'experimentation-client-js';

import { EPPO_EVENT_SOURCE } from 'constants/eppo';

let sharedClient: FirehoseClient | null = null;

export const createEventWriter = (): EventWriter => {
    if (!sharedClient) {
        sharedClient = new FirehoseClient({
            region: import.meta.env.REGION,
            credentials: fromCognitoIdentityPool({
                clientConfig: { region: import.meta.env.REGION },
                identityPoolId: import.meta.env.FIREHOSE_AWS_ID,
            }),
        });
    }

    const firehose = sharedClient;

    return {
        streamName: import.meta.env.FIREHOSE_STREAM_NAME,
        eventSourceName: EPPO_EVENT_SOURCE,
        sendRecord: async (event) => {
            try {
                if (typeof firehose.config.credentials === 'function') {
                    await firehose.config.credentials();
                }

                const payload =
                    event && typeof event === 'object'
                        ? { ...event, __source: EPPO_EVENT_SOURCE }
                        : { value: event, __source: EPPO_EVENT_SOURCE };

                const data = new TextEncoder().encode(JSON.stringify(payload));

                const cmd = new PutRecordCommand({
                    DeliveryStreamName: import.meta.env.FIREHOSE_STREAM_NAME,
                    Record: { Data: data },
                });

                await firehose.send(cmd);

                return true;
            } catch (error) {
                return false;
            }
        },
    };
};
